module.exports = __webpack_public_path__ + "img/pencil.5f017b03.svg";